import { motion, AnimatePresence } from 'framer-motion';
import { useGameStore } from '../../store/gameStore';
import { Link } from 'react-router-dom';

export default function PauseOverlay() {
  const { isPaused, togglePause } = useGameStore();

  return (
    <AnimatePresence>
      {isPaused && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 z-40 flex items-center justify-center bg-sudoku-bg/90 backdrop-blur-md rounded-2xl"
        >
          <div className="text-center">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: 'spring' }}
              className="text-6xl mb-4"
            >
              ⏸️
            </motion.div>
            <h3 className="text-2xl font-bold mb-6">游戏暂停</h3>
            <div className="flex flex-col gap-3">
              <button onClick={togglePause} className="btn-primary">
                继续游戏
              </button>
              <Link to="/levels" className="btn-secondary text-center">
                返回关卡选择
              </Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

